export const getRoleName = (role) => {
  if (typeof role === "object") {
    return role?.roleName || role?.name || "";
  }

  return String(role || "");
};

export const getNotificationRoleSegment = (role) => {
  const roleName = getRoleName(role).trim();

  if (!roleName) {
    return "";
  }

  switch (roleName.replace(/\s+/g, " ").toUpperCase()) {
    case "DID":
      return "DID";
    case "REGIONAL LEAD":
      return "RegionalLead";
    case "ADMIN":
      return "Admin";
    default:
      return roleName.replace(/\s+/g, "");
  }
};
